<div class="cont-tabla-excel-det-prods" style="border-radius: 10px 10px 0px 0px; overflow: hidden">
      <!-- cant:{arrDatos.length} -->
      <table class="tabla-det-productos-tipo-excel">
            <thead>
                  <th>Producto</th>
                  <th class="center">Precio Unitario</th>
                  <th class="center">Cantidad</th>
                  <th class="center">Precio Total</th>
                  <th class="center">Quitar</th>
            </thead>
            <tbody>
                  {#each arrDatos as datoLoop, index}
                        <tr class="table-row">
                              <td class="bold pl-3">
                                    <InputExcel bind:value={datoLoop.nombre} />
                              </td>
                              <td class="center">
                                    <InputExcel
                                          tipo="moneda"
                                          w="80px"
                                          bind:value={datoLoop.precioUnitario}
                                    />
                                    <!-- {"$" + datoLoop.precioUnitario} -->
                              </td>
                              <td class="flex-center-h flex-center-v">
                                    <InputCant bind:value={datoLoop.cantidad} />
                              </td>
                              <td class="center bold"
                                    >{"$" + datoLoop.cantidad * datoLoop.precioUnitario}</td
                              >
                              <td class="center bold">
                                    <BotonX icono="trash" on:click={rmElement(index)} />
                              </td>
                        </tr>
                  {/each}
            </tbody>
      </table>
</div>

<script>
      import BotonX from "./BotonX.svelte";
      import InputExcel from "./InputExcel.svelte";
      import InputCant from "./InputCant.svelte";
      export let arrDatos = [
            { nombre: "Producto 1", precioUnitario: 1250, cantidad: 3 },
            { nombre: "Producto 2", precioUnitario: 1500, cantidad: 3 },
            { nombre: "Producto 3", precioUnitario: 1520, cantidad: 3 },
      ];
      function rmElement(indiceElementoRM) {
            arrDatos.splice(indiceElementoRM, 1);
      }
      // export let arrProductos = [
      //       { nombre: "Producto 1", precioUnitario: 1250, cantidad: 3 },
      //       { nombre: "Producto 2", precioUnitario: 1500, cantidad: 3 },
      //       { nombre: "Producto 3", precioUnitario: 1520, cantidad: 3 },
      // ];
</script>

<style>
      .tabla-det-productos-tipo-excel {
            width: 100%;
            border: solid 2px #7f56da;
      }
      .table-row {
            /* border: solid 1px red; */
            padding: 12px;
      }
      tbody {
            border: solid 2px #7f56da;
      }
      th {
            background-color: #7f56da;
            color: white;
            padding: 8px;
      }
      td {
            padding-top: 12px;
            padding-bottom: 12px;
            border-right: solid 2px #7f56da;
      }
</style>
